import { trim } from "lodash";
import { isEmail } from "components/utils/validation";

// Guests sign in with an email address and have no first or last name, so their messages come with a blank user name or the email.
export const isGuestSender = (userName?: string) => trim(userName) === "" || isEmail(trim(userName));

export const getSenderName = (userName?: string) => {
    const name = trim(userName);

    if (!isGuestSender(name)) {
        return name;
    }

    return name ? `Guest user (${name})` : "Guest user";
};
